import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { findWhere, without } from '../utilities';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  private modals: any[] = [];  // list of modals dialog divs displayed in application (splashscreen & alert dialog)
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any) { this.isBrowser = isPlatformBrowser(platformId); }

  // called on the init event of any modal dialog (/layout/components/dialog.component.ts)
  addModalDialog(modal: any): void {
    this.modals.push(modal);
  }

  // called on the destroy event of any modal dialog (/layout/components/dialog.component.ts)
  removeModalDialog(id: string): void {
    const modalToRemove: any = findWhere(this.modals, id);
    this.modals = without(this.modals, [modalToRemove]);
  }

  // display the modal dialog specified by the id parameter
  openModal(id: string): void {
    const modal: any = findWhere(this.modals, id);
    if (modal) {
      modal.open();
    } else {
      if (this.isBrowser) {
        const splash: HTMLElement | null = document.getElementById('divCustomSpash');
        if (splash) {
          splash.style.display = 'block';
        }
      }
    }
  }

  // hide the modal dialog specified by the id parameter
  closeModal(id: string): void {
    const modal: any = findWhere(this.modals, id);
    if (modal) {
      modal.close();
    } else {
      if (this.isBrowser) {
        const splash: HTMLElement | null = document.getElementById('divCustomSpash');
        if (splash) {
          splash.style.display = 'none';
        }
      }
    }
  }

  // hide all of the modal dialogs listed in the correspondent collection
  closeAllModals(): void {
    for (const modal of this.modals) {
      modal.close();
    }
  }

  // show/hide splashscreen
  showSplash(show: boolean): void {

    const splash: HTMLElement | null = document.getElementById('divCustomSpash');
    if (splash) {
      splash.style.display = show ? 'block' : 'none';
    }

    //////if (show) {
    //////  this.openModal('splashscreen');
    //////} else {
    //////  this.closeModal('splashscreen');
    //////}
  }

  showSplash2(splashId: string, show: boolean): void {
    if (this.isBrowser) {
      const splash: HTMLElement | null = document.getElementById(splashId);
      if (splash) {
        splash.style.display = show ? 'block' : 'none';
      }
    }
  }

  // show/hide splashscreen
  showSplashInvisible(show: boolean): void {
    if (show) {
      this.openModal('splashinvisible');
    } else {
      this.closeModal('splashinvisible');
    }
  }

  // show alert message
  showAlert(message: string, titlealert?: string, type?: string): void {
    titlealert = !titlealert ? '' : titlealert;
    type = !type ? '' : type;
    const modal: any = findWhere(this.modals, 'commonalert');
    if (modal) {
      modal.openMessage(message, 'pTarget', titlealert, type);
    }
  }

}

